export const CREATE_PROGRAM_DETAILS_REQUEST = 'CREATE_PROGRAM_DETAILS_REQUEST';
export const CREATE_PROGRAM_DETAILS_SUCCESS = 'CREATE_PROGRAM_DETAILS_SUCCESS';
export const CREATE_PROGRAM_DETAILS_FAILED = 'CREATE_PROGRAM_DETAILS_FAILED';

export const UPLOAD_SANDBOX_REQUEST = 'UPLOAD_SANDBOX_REQUEST';
export const UPLOAD_SANDBOX_SUCCESS = 'UPLOAD_SANDBOX_SUCCESS';
export const UPLOAD_SANDBOX_FAILED = 'UPLOAD_SANDBOX_FAILED';

export const CREATE_PROGRAM_COMMITMENTS_REQUEST =
  'CREATE_PROGRAM_COMMITMENTS_REQUEST';
export const CREATE_PROGRAM_COMMITMENTS_SUCCESS =
  'CREATE_PROGRAM_COMMITMENTS_SUCCESS';
export const CREATE_PROGRAM_COMMITMENTS_FAILED =
  'CREATE_PROGRAM_COMMITMENTS_FAILED';

export const SAVE_PROGRAM_COMMITMENTS = 'SAVE_PROGRAM_COMMITMENTS';
export const UPDATE_PROGRAM_DAY_DETAILS_REQUEST =
  'UPDATE_PROGRAM_DAY_DETAILS_REQUEST';
export const UPDATE_PROGRAM_DAY_DETAILS_SUCCESS =
  'UPDATE_PROGRAM_DAY_DETAILS_SUCCESS';

export const UPDATE_PROGRAM_DAY_DETAILS_FAILED =
  'UPDATE_PROGRAM_DAY_DETAILS_FAILED';

export const UPDATE_PROGRAM_STATUS_REQUEST = 'UPDATE_PROGRAM_STATUS_REQUEST';
export const UPDATE_PROGRAM_STATUS_SUCCESS = 'UPDATE_PROGRAM_STATUS_SUCCESS';
export const UPDATE_PROGRAM_STATUS_FAILED = 'UPDATE_PROGRAM_STATUS_FAILED';

export const UPDATE_PROGRAM_PUBLISH_STATUS_REQUEST =
  'UPDATE_PROGRAM_PUBLISH_STATUS_REQUEST';
export const UPDATE_PROGRAM_PUBLISH_STATUS_SUCCESS =
  'UPDATE_PROGRAM_PUBLISH_STATUS_SUCCESS';
export const UPDATE_PROGRAM_PUBLISH_STATUS_FAILED =
  'UPDATE_PROGRAM_PUBLISH_STATUS_FAILED';

export const UPDATE_PROGRAM_DETAILS_REQUEST = 'UPDATE_PROGRAM_DETAILS_REQUEST';
export const UPDATE_PROGRAM_DETAILS_SUCCESS = 'UPDATE_PROGRAM_DETAILS_SUCCESS';
export const UPDATE_PROGRAM_DETAILS_FAILED = 'UPDATE_PROGRAM_DETAILS_FAILED';

export const CLEAR_PROGRAM_SUCCESS = 'CLEAR_PROGRAM_SUCCESS';

export const GET_PROGRAM_PUBLISH_REQUEST = 'GET_PROGRAM_PUBLISH_REQUEST';
export const GET_PROGRAM_PUBLISH_SUCCESS = 'GET_PROGRAM_PUBLISH_SUCCESS';
export const GET_PROGRAM_PUBLISH_FAILED = 'GET_PROGRAM_PUBLISH_FAILED';

export const SEARCH_PROGRAM_REQUEST = 'SEARCH_PROGRAM_REQUEST';
export const SEARCH_PROGRAM_SUCCESS = 'SEARCH_PROGRAM_SUCCESS';
export const SEARCH_PROGRAM_FAILED = 'SEARCH_PROGRAM_FAILED';

export const REMOVE_PROGRAM_REQUEST = 'REMOVE_PROGRAM_REQUEST';
export const REMOVE_PROGRAM_SUCCESS = 'REMOVE_PROGRAM_SUCCESS';
export const REMOVE_PROGRAM_FAILED = 'REMOVE_PROGRAM_FAILED';

export const REMOVE_COMMITMENT_REQUEST = 'REMOVE_COMMITMENT_REQUEST';
export const REMOVE_COMMITMENT_SUCCESS = 'REMOVE_COMMITMENT_SUCCESS';
export const REMOVE_COMMITMENT_FAILED = 'REMOVE_COMMITMENT_FAILED';

export const GET_PROGRAM_CATEGORY_REQUEST = 'GET_PROGRAM_CATEGORY_REQUEST';
export const GET_PROGRAM_CATEGORY_SUCCESS = 'GET_PROGRAM_CATEGORY_SUCCESS';
export const GET_PROGRAM_CATEGORY_FAILED = 'GET_PROGRAM_CATEGORY_FAILED';

export const GET_EXPLORE_CONTENT_REQUEST = 'GET_EXPLORE_CONTENT_REQUEST';
export const GET_EXPLORE_CONTENT_SUCCESS = 'GET_EXPLORE_CONTENT_SUCCESS';
export const GET_EXPLORE_CONTENT_FAILED = 'GET_EXPLORE_CONTENT_FAILED';

export const SAVE_SINGLE_COMMITMENT_DETAILS = 'SAVE_SINGLE_COMMITMENT_DETAILS';

export const createProgramDetails = (data) => {
  return { type: CREATE_PROGRAM_DETAILS_REQUEST, payload: data };
};

export const createProgramCommitments = (data) => {
  return { type: CREATE_PROGRAM_COMMITMENTS_REQUEST, payload: data };
};

export const updateProgramDayDetails = (data) => {
  return { type: UPDATE_PROGRAM_DAY_DETAILS_REQUEST, payload: data };
};

export const uploadSandBox = (data) => {
  return { type: UPLOAD_SANDBOX_REQUEST, payload: data };
};
export const getProgramPublishDetail = (data) => {
  return { type: GET_PROGRAM_PUBLISH_REQUEST, payload: data };
};
export const updateProgramStatus = (data) => {
  return { type: UPDATE_PROGRAM_STATUS_REQUEST, payload: data };
};
export const updateProgramPublishStatus = (data) => {
  return { type: UPDATE_PROGRAM_PUBLISH_STATUS_REQUEST, payload: data };
};
export const updateProgramDetails = (data) => {
  return { type: UPDATE_PROGRAM_DETAILS_REQUEST, payload: data };
};
export const searchProgram = (data) => {
  return { type: SEARCH_PROGRAM_REQUEST, payload: data };
};
export const RemoveProgram = (data) => {
  return { type: REMOVE_PROGRAM_REQUEST, payload: data };
};
export const RemoveCommitmentDetails = (data) => {
  return { type: REMOVE_COMMITMENT_REQUEST, payload: data };
};
export const getExploreContent = () => {
  return { type: GET_EXPLORE_CONTENT_REQUEST };
};
export const getProgramCategory = () => {
  return { type: GET_PROGRAM_CATEGORY_REQUEST };
};
